import { isPriceForSize, type PriceForSize } from './priceForSizes';

/** Only the bounded collection sizes may create a product-page price variant. */
export function collectionSizeFromQuery(query: Record<string, string | string[] | undefined>): PriceForSize | undefined {
  if (typeof query.width !== 'string' || typeof query.height !== 'string') return;
  const width = Number(query.width);
  const height = Number(query.height);
  return isPriceForSize(width, height) ? { width, height } : undefined;
}

export function collectionPurchaseUrl(slug: string, size?: PriceForSize, configure = false): string {
  const path = `/products/${configure ? 'configure/' : ''}${encodeURIComponent(slug)}`;
  if (!size || !isPriceForSize(size.width, size.height)) return path;
  return `${path}?width=${size.width}&height=${size.height}`;
}
